export default function ContactFooterSection() {
  return (
    <footer className="w-full bg-background-50 py-16 md:py-24">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        {/* Black rounded container */}
        <div className="bg-primary-900 rounded-[32px] p-10 md:p-14 lg:p-16">
          {/* Upper: Three-column contact layout */}
          <div className="grid grid-cols-1 md:grid-cols-[2fr_1fr_1.5fr] gap-10 md:gap-8">
            {/* Left column: Contact title + email */}
            <div>
              <h2 className="font-heading text-background-50"
                style={{ fontSize: 'clamp(2rem, 3.5vw, 2.8rem)' }}
              >
                Contact
              </h2>
              <p className="text-sm text-foreground-400/80 mt-4 leading-relaxed max-w-[340px]">
                For inquiries about engineering services and collaborations,
                reach out through the contact details below.
              </p>
              <div className="mt-16">
                <p className="font-body text-background-50/90 text-base">
                  info@aeternasoftware.com
                </p>
              </div>
            </div>

            {/* Middle column: Address */}
            <div>
              <h3 className="text-[11px] uppercase tracking-[0.15em] text-foreground-400/60 font-label mb-5">
                Address
              </h3>
              <div className="space-y-1.5">
                <p className="text-sm text-background-50/80 leading-relaxed">Perkunkiemio g. 20</p>
                <p className="text-sm text-background-50/80 leading-relaxed">Vilnius</p>
                <p className="text-sm text-background-50/80 leading-relaxed">12121</p>
                <p className="text-sm text-background-50/80 leading-relaxed">Lithuania</p>
              </div>
            </div>

            {/* Right column: Phone & email */}
            <div>
              <h3 className="text-[11px] uppercase tracking-[0.15em] text-foreground-400/60 font-label mb-5">
                Reach
              </h3>
              <div className="space-y-4">
                <p className="text-sm text-background-50/80 leading-relaxed">+370 66806272</p>
                <p className="text-sm text-foreground-400/80 leading-relaxed">info@aeternasoftware.com</p>
              </div>
            </div>
          </div>

          {/* Divider */}
          <div className="mt-14 pt-8 border-t border-foreground-700/30">
            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3 sm:gap-0">
              <p className="text-xs text-foreground-400/50 sm:flex-1">
                Perkunkiemio g. 20
              </p>
              <p className="text-xs text-foreground-400/50 text-center sm:flex-1 sm:text-center">
                &copy; 2026
              </p>
              <p className="text-xs text-foreground-400/50 sm:flex-1 sm:text-right">
                Vilnius, Lithuania
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}